/**
 * 实际到账计算工具
 *
 * 支付方式字典(pay_fee_detail.prime_rate statusCd)到账口径:
 * 3=微信二维码 4=支付宝二维码 5=微信公众号支付 6=微信小程序支付 → 走 MOOFS 渠道,收取千分之三手续费,到账=实收×0.997
 * 1=现金 2=POS 7=转账 → 线下实收,到账=实收
 * 8=押金退款转账户 11=预存抵扣(系统自动扣费)→ 内部划转,无新增资金流入,到账=0
 */
export const MOOFS_PRIME_RATES = ['3', '4', '5', '6']
export const OFFLINE_PRIME_RATES = ['1', '2', '7']
export const MOOFS_ARRIVAL_RATE = 0.997

// prime_rate 落库为 decimal(10,2),接口返回形如 "5.00",匹配前规范化为 "5"
function normalizePrimeRate(primeRate) {
  if (primeRate === null || primeRate === undefined || primeRate === '') {
    return primeRate
  }
  const num = Number(primeRate)
  return Number.isNaN(num) ? String(primeRate).trim() : String(num)
}

export function isMoofsChannel(primeRate) {
  return MOOFS_PRIME_RATES.includes(normalizePrimeRate(primeRate))
}

export function calcArrivalAmount(primeRate, receivedAmount) {
  const received = Number(receivedAmount) || 0
  const rate = normalizePrimeRate(primeRate)
  if (MOOFS_PRIME_RATES.includes(rate)) {
    return (Math.round(received * MOOFS_ARRIVAL_RATE * 100) / 100).toFixed(2)
  }
  if (OFFLINE_PRIME_RATES.includes(rate)) {
    return received.toFixed(2)
  }
  return (0).toFixed(2)
}
